import React from "react";

const DisabledAccount = () => {
    return (
        <div className="w-100 text-center" style={{height: '100vh'}}>
            <p className="text-danger" style={{paddingTop: '48vh'}}>Account is disabled. Contact PEA HOME.</p>
        </div>
    )
}

export default DisabledAccount;